import React from "react";
import Pages from "./components/page/Pages";
import "./App.css"
function App() {
  return (
    <div>
      <Pages />
    </div>
  );
}

export default App;
